import { getCompanyPerformanceQuestionList } from 'api/hooks/company-performance-question/companyPerformanceQuestionsService';
import { CompanyPerformanceQuestionListResponse } from 'api/hooks/company-performance-question/companyPerformanceQuestionsTypes';

import { useQuery } from 'react-query';

type Props<M> = {
    onError?: (error: Error) => void;
    onSuccess?: (data: CompanyPerformanceQuestionListResponse) => void;
    mapper?: (
        data?: CompanyPerformanceQuestionListResponse
    ) => M | CompanyPerformanceQuestionListResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: CompanyPerformanceQuestionListResponse) => data;

export const useGetCompanyPerformanceQuestionList = <
    M = CompanyPerformanceQuestionListResponse
>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
}: Props<M>) => {
    const query = useQuery<CompanyPerformanceQuestionListResponse, Error>(
        ['companyPerformanceQuestions'],
        getCompanyPerformanceQuestionList,
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
